import type { ReactNode } from "react"
import i18n from "@/i18n"

export type MenuItem = {
  label: string
  path: string
  external?: boolean
  icon?: ReactNode
  testId?: string
}

export type MenuGroup = {
  title: string
  items?: MenuItem[]
  subGroups?: Record<string, MenuGroup>
  icon?: ReactNode
  testId?: string
}

export type MenuStructure = Record<string, MenuGroup>

export const getMenuStructure = (): MenuStructure => ({
  profile: {
    title: i18n.t("app.settings.sidebar.profile.title"),
    testId: "settings-sidebar-profile-section",
    items: [
      {
        label: i18n.t("app.settings.sidebar.profile.overview"),
        path: "settings/profile/overview",
        testId: "settings-sidebar-profile-overview-link",
      },
      {
        label: i18n.t("app.settings.sidebar.profile.change_password"),
        path: "settings/profile/change_password",
        testId: "settings-sidebar-profile-password-link",
      },
    ],
  },
  users: {
    title: i18n.t("app.settings.sidebar.users.title"),
    testId: "settings-sidebar-users-section",
    items: [
      {
        label: i18n.t("app.settings.sidebar.users.user_list"),
        path: "settings/users/list",
        testId: "settings-sidebar-users-list-link",
      },
      {
        label: i18n.t("app.settings.sidebar.users.roles_permissions"),
        path: "settings/users/roles",
        testId: "settings-sidebar-users-roles-link",
      },
    ],
  },
})
